import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=42b05d52&"
import script from "./text-input.vue?vue&type=script&lang=ts&"
export * from "./text-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports